import endpoints from "../config/endpoints";
import api from "../config/axios";

export const GetAllCategories = async (params) => {
    try {
        let query = "";
        if (params !== undefined) {
            let queryParts = [];
            Object.keys(params).forEach(key => {
                const value = params[key];
                if (Array.isArray(value)) {
                    value.forEach(val => {
                        queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
                    });
                } else if (value !== null && value !== undefined) {
                    queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
                }
            });
            query = queryParts.join('&');
        }

        const response = await api.get(`${endpoints.Category.GetAllCategories}?${query}`);

        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error fetching orders:', error);
        return {
            data: [],
            status: false,
            statusCode: 500,
            message: 'Error fetching products',
        };
    }
};

export const AddCategory = async (categoryData) => {
    try {
        const response = await api.post(endpoints.Category.AddCategory, categoryData);
        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error adding category:', error);
        return {
            data: [],
            status: false,
            statusCode: 500,
            message: 'Error adding category',
        };
    }
};

export const UpdateCategory = async (categoryId,categoryData) => {
    try {
        const response = await api.put(`${endpoints.Category.UpdateCategory}?id=${categoryId}`, categoryData);
        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error updating category:', error);
        return {
            data: [],
            status: false,
            statusCode: 500,
            message: 'Error updating category',
        };
    }
};

export const DeleteCategory = async (categoryId) => {
    try {
        const response = await api.delete(`${endpoints.Category.DeleteCategory}?id=${categoryId}`);
        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error fetching orders:', error);
        return {
            data: [],
            status: false,
            statusCode: 500,
            message: 'Error fetching products',
        };
    }
};

const CategoryService = {
    GetAllCategories,
    AddCategory,
    DeleteCategory
};

export default CategoryService;